import { GradientButton } from './gradient-button'

export const SecondaryGradientButton: React.FC<IGradientButton> = (props) => (
  <GradientButton gradient="secondary" {...props} />
)
